import {NotificationInfo} from "../models/Notification";

export interface INotificationService {
    alertNotification(info: NotificationInfo): void
    alertError(text:string, header?:string,): void
    alertSuccess(text:string, header?:string,): void
}

export class NotificationService implements INotificationService {

    private static instance: NotificationService;
    private eventHandler: ((info: NotificationInfo) => void) | undefined

    private constructor() {
    }

    public static getInstance(): NotificationService {
        if (!NotificationService.instance) {
            NotificationService.instance = new NotificationService();
        }

        return NotificationService.instance;
    }

    subscribe(eh: (info: NotificationInfo) => void) {
        NotificationService.instance.eventHandler = eh;
    }

    alertNotification(info: NotificationInfo): void {
        if (NotificationService.instance.eventHandler) {
            NotificationService.instance.eventHandler(info);
        }
    }

    alertError(text: string, header?: string ): void {
        if (!header) {
            header = 'Упс, что то пошло не так.'
        }
        NotificationService.instance.alertNotification({
            header: header,
            text: text,
            type: 'error'
        })
    }

    alertSuccess(text: string, header?: string ): void {
        if (!header) {
            header = 'Успешно.'
        }
        NotificationService.instance.alertNotification({
            header: header,
            text: text,
            type: 'success'
        })
    }
}